import React, { useEffect, useState } from "react";
import { Popup } from "../../../../UI/Popup/Popup";
import arrowRightUp from "../../../../../../assets/images/gf_arrow_right_up.png";
import styles from "./AssignedTestPopup.module.css";

export const AssignedTestPopup = ({ open, onClose, onStartTest }) => {
  const [isStarting, setIsStarting] = useState(false);

  // Reset the loading state whenever the popup closes/reopens (this component
  // stays mounted and only returns null while closed).
  useEffect(() => {
    if (!open) setIsStarting(false);
  }, [open]);

  if (!open) return null;

  const handleStartClick = () => {
    if (isStarting) return;
    // Launching navigates to the assessment web (a brief delay); show a loading
    // state until then, reset only if navigation didn't actually start.
    setIsStarting(true);
    if (onStartTest?.() === false) setIsStarting(false);
  };

  return (
    <Popup onClose={onClose} contentClassName={styles.content}>
      <div className={styles.title}>Your mentor has just assigned a test to you</div>
      <button
        type="button"
        className={styles.startBtn}
        onClick={handleStartClick}
        disabled={isStarting}
      >
        Start the test
        {isStarting ? (
          <span className={styles.btnSpinner} role="status" aria-label="Starting test" />
        ) : (
          <img src={arrowRightUp} alt="" className={styles.btnIcon} />
        )}
      </button>
    </Popup>
  );
};
